export const LINKEDIN_PAGE = "https://linkedin.com/company/onegradai/";
